import * as actions from './draggableSlotsActions';
import reducer, { DRAGGABLE_SLOTS } from './draggableSlotsReducer';
import * as selectors from './draggableSlotsSelectors';

export { actions, reducer, selectors, DRAGGABLE_SLOTS };
